import api from '@/api';

const actions = {
  FETCH_TIME_ZONES: async ({ commit, state }) => {
    if (state.timeZones) {
      return state.timeZones;
    }

    const timeZones = await api.fetchTimeZones();

    commit('SET_TIME_ZONES', { timeZones });

    return timeZones;
  },
};

export default actions;
